// This file uses build-time replacement to inject the version from package.json
export const SDK_VERSION = '__SDK_VERSION__'
